import styled from 'styled-components'
import { RegularButtonWrapper } from '@monthio/react-components'

export const PopularBanksGrid = styled.div`
	width: 100%;
	display: grid;
	grid-gap: ${(props) => props.theme.spacing(2)}px;
	grid-template-columns: 1fr 1fr;

	${(props) => props.theme.breakpoints.up('sm')} {
		grid-gap: ${(props) => props.theme.spacing(4)}px;
		grid-template-columns: 1fr 1fr 1fr;
	}
`

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	${(props) => props.theme.breakpoints.up('sm')} {
		flex-direction: row;
	}
`

export const ListContainer = styled.div`
	width: 100%;
	box-shadow: 0px 0px 14px rgba(53, 64, 82, 0.05);
	border: 0px solid #eeee;
	border-radius: ${(props) => props.theme.body.borderRadius}px;
	border-top: 1px solid #cccccc;
	background-color: white;
`

export const SearchBarContainer = styled.div<{ $isActive: boolean }>`
	width: 100%;

	padding-bottom: ${(props) => (props.$isActive ? '0px' : '24px')};

	${(props) => props.theme.breakpoints.up('sm')} {
		padding-bottom: ${(props) => (props.$isActive ? '0px' : '32px')};
	}
`

export const CompanyLogo = styled.img`
	height: 80px;
	width: auto;

	@media only screen and (max-width: 680px) {
		height: 36px;
	}
`

export const StyledRegularButtonWrapper = styled(RegularButtonWrapper)`
	> button {
		min-height: unset;
		height: 38px;
	}
`
